class GroupResponseService {
    createResponse(valid, value, errorCode, errorMessage) {
        const response = {
            valid: !!valid,
            value,
            error: {},
        };

        if (!valid) {
            response.value = '';
            response.error = {
                code: errorCode,
                message: errorMessage,
            };
        }

        return response;
    }
}

export default new GroupResponseService();
